import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestCommentAttachments = async (commentId) => {
  return await request.get(
    `/Request/request_note_attachments/${commentId}`,
    {},
    'Не удалось загрузить вложения',
    []
  );
};

const useRequestCommentAttachments = (commentId, hasAttachment) =>
  useQuery([`commentAttachments`, commentId, hasAttachment], () => getRequestCommentAttachments(commentId), {
    placeholderData: [],
    enabled: hasAttachment,
  });

export default useRequestCommentAttachments;
